// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6":"2d60dbab","32":"a028df83","75":"3fd52232","349":"2d60dbab","352":"2d60dbab","561":"657b10ba","826":"2d60dbab","949":"3fd52232"}[chunkId] + ".chunk.css";
};